<template>
  <div class="page">
    <div class="card" style="max-width: 720px;">
      <div class="card-header">
        <div>
          <h1 class="title">Seguranca do trabalho</h1>
          <p class="subtitle">Selecione o tipo de documento.</p>
        </div>
        <span class="pill">Novo</span>
      </div>

      <div class="grid" style="gap: 12px;">
        <button class="item-card" type="button" @click="goDialogo">
          <strong>Dialogos de Seguranca</strong>
          <div class="item-meta">Registro de dialogo com equipe.</div>
        </button>
        <button class="item-card" type="button" @click="goPermissao">
          <strong>Permissao de Trabalho Critico</strong>
          <div class="item-meta">Documento critico de seguranca.</div>
        </button>
        <button class="item-card" type="button" @click="goOcorrido">
          <strong>Relatorio de Ocorrido</strong>
          <div class="item-meta">Descreva um ocorrido e anexe imagens.</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'SafetyCreateView',
  setup() {
    const router = useRouter()
    const goDialogo = () => router.push('/safety/dialogo')
    const goPermissao = () => router.push('/forgot')
    const goOcorrido = () => router.push('/safety/ocorrido')

    return { goDialogo, goPermissao, goOcorrido }
  }
})
</script>
